<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">CERTIFICATE</div>
          <div class="eng-font">证书介绍及报考</div>
        </div>
      </div>
      <div class="certificate-list-right">
        <div class="article-panel" v-if="article">
          <p class="article-title">{{ article.name }}</p>
          <div class="time">
            <div>{{ article.release_time }}</div>
            <div class="laiyuan">
              <div><img src="../../assets/laiyuan.png" alt="" width="20" /></div>
              <span>博努力</span>
            </div>
          </div>
          <div class="divider"></div>
          <div class="article-content" v-html="article.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadCategoryArticle } from "./loadCategoryArticle";

export default {
  data() {
    return {
      article: null,
    };
  },
  mounted() {
    loadCategoryArticle("证书介绍及报考").then((article) => {
      this.article = article;
    });
  },
};
</script>

<style scoped>
.partner {
  background-color: white;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.certificate-list-left {
  float: left;
  width: 185px;
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}
.eng {
  font-size: 16px;
  color: #666666;
}
.eng-font {
  font-size: 26px;
}
.article-panel {
  padding: 30px 50px 100px 50px;
}
.article-title {
  font-size: 24px;
  font-weight: bold;
  color: #4a4a4a;
  text-align: center;
  margin-bottom: 30px;
}
.time {
  height: 23px;
  line-height: 23px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 12px;
  color: #4a4a4a;
  padding: 0 20px;
}
.laiyuan {
  display: flex;
}
.divider {
  width: 100%;
  height: 1px;
  margin: 30px 0 50px;
  background: #e5e5e5;
}
.article-content {
  font-size: 16px !important;
  color: #4f4f4f;
  line-height: 30px;
  padding: 0 20px;
  text-indent: 0;
}
.article-content >>> img,
.article-content /deep/ img {
  max-width: 100% !important;
  width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto 16px;
}
</style>
